import {
  QUERY_KEY_MY_MONITORING_GET_CONTROL_FOR_EDIT,
  QUERY_KEY_MY_MONITORING_GET_CONTROL_LIST_WITH_STATE,
  QUERY_KEY_MY_MONITORING_GET_CONTROL_SELECT_LIST_WITH_STATE
} from '@apps-common/apis/my-monitoring/control'
import {
  QUERY_KEY_PORTAL_GET_UNIT_CONTROL,
  QUERY_KEY_PORTAL_GET_UNIT_CONTROLS_LIST_WITH_STATE,
  QUERY_KEY_PORTAL_GET_UNIT_CONTROL_SELECT_LIST_WITH_STATE
} from '@apps-common/apis/portal/control'
import { queryClient } from '@apps-common/lib'

export const invalidateAllControlQueries = (unitId?: string, controlId?: number) => {
  invalidateControlListQueries(unitId)
  invalidateControlQueries(controlId)
}

export const invalidateControlListQueries = (unitId?: string) => {
  // my monitoring
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_MY_MONITORING_GET_CONTROL_LIST_WITH_STATE(unitId) })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_MY_MONITORING_GET_CONTROL_SELECT_LIST_WITH_STATE(unitId) })

  // portal
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_PORTAL_GET_UNIT_CONTROLS_LIST_WITH_STATE(unitId) })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_PORTAL_GET_UNIT_CONTROL_SELECT_LIST_WITH_STATE(unitId) })
}

export const invalidateControlQueries = (controlId?: number) => {
  // my monitoring
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_MY_MONITORING_GET_CONTROL_FOR_EDIT(controlId) })

  // portal
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_PORTAL_GET_UNIT_CONTROL(controlId) })
}
